import { render, staticRenderFns } from "./public-debt-info.vue?vue&type=template&id=10780615&scoped=true"
import script from "./public-debt-info.vue?vue&type=script&lang=ts"
export * from "./public-debt-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10780615",
  null
  
)

export default component.exports